import logo from '../assets/logo/Dira-Holidays-Logo.png';
import { Icon } from './Icons';


const SOCIAL = [
  { label: 'Facebook', icon: 'https://cdn.simpleicons.org/facebook/1877F2', url: 'https://www.facebook.com/share/17zHdjmkxq/' },
  { label: 'Instagram', icon: 'https://cdn.simpleicons.org/instagram/E1306C', url: 'https://www.instagram.com/diraholidays?igsh=MTc3ZTJ6b28wd3h1ag==' },
  { label: 'LinkedIn', icon: 'https://upload.wikimedia.org/wikipedia/commons/8/81/LinkedIn_icon.svg', url: 'https://www.linkedin.com/company/diraholidays/' },
  { label: 'YouTube', icon: 'https://cdn.simpleicons.org/youtube/FF0000', url: 'https://www.youtube.com/@Diraholidays' },
];

const PAYMENT_OPTIONS = [
  { label: 'Apple Pay', icon: 'https://cdn.simpleicons.org/applepay/ffffff' },
  { label: 'Visa', icon: 'https://cdn.simpleicons.org/visa/1a1f71' },
  { label: 'Mastercard', icon: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg' },
  { label: 'UPI', icon: 'https://upload.wikimedia.org/wikipedia/commons/e/e1/UPI-Logo-vector.svg' },
  { label: 'Google Pay', icon: 'https://upload.wikimedia.org/wikipedia/commons/f/f2/Google_Pay_Logo.svg' },
  { label: 'PhonePe', icon: 'https://cdn.simpleicons.org/phonepe/5f259f' },
];

const BRAND_LINKS = [
  'DIRA HOLIDAYS Retreats', 'DIRA HOLIDAYS Adventures', 'DIRA HOLIDAYS Nomad', 'DIRA HOLIDAYS Wanderlust',
  'DIRA HOLIDAYS Explorer', 'DIRA HOLIDAYS Getaways', 'DIRA HOLIDAYS Escapes', 'DIRA HOLIDAYS Blind Date', 'DIRA HOLIDAYS Honeymoon',
  
];

const DEST_LINKS = [
  'Popular Holiday Types', 'Holiday Destinations', 'Long Haul Destinations',
  'City Destinations', 'Beach Holidays', 'Mountain Treks', 'Luxury Retreats', 'Honeymoon Packages',
];

const SUPPORT_LINKS = ['Help Centre', 'Track Booking', 'Cancel / Modify', 'Visa Assistance', 'Travel Insurance', 'Corporate Enquiry'];

const LEGAL_LINKS = ['About us', 'Press enquiries', 'Terms and conditions', 'Privacy policy', 'Cookie policy', 'Price match', 'Contact us', 'Sitemaps'];

const USP = [
  { icon: 'dollar',  title: 'Spread the Costs', desc: 'Pay monthly without any extra fees' },
  { icon: 'tag',     title: 'Low Deposit',       desc: 'Secure your next holiday from £39pp' },
  { icon: 'clock',   title: '24/7 Support',      desc: 'Expert help whilst you are on holiday' },
  { icon: 'check',   title: 'Price Match',       desc: 'Know you are getting the best holiday deal' },
];

export default function Footer() {
  return (
    <footer style={{ background: 'var(--brand-deep)' }}>

      {/* USP Bar */}
      <div style={{ background: 'var(--brand-deep)', borderTop: '1px solid #0b1117', borderBottom: '1px solid #0b1117', padding: '28px 32px' }}>
        <div className="footer-usp-grid" style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '24px' }}>
          {USP.map(u => (
            <div key={u.title} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
              <div style={{ width: '36px', height: '36px', background: 'rgba(2,2,191,0.2)', borderRadius: '9px',border: '0.5px solid #ffffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Icon name={u.icon} size={17} color="var(--secondary)" />
              </div>
              <div>
                <div style={{ fontSize: '13px', fontWeight: 700, color: '#fff', marginBottom: '3px' }}>{u.title}</div>
                <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', lineHeight: 1.55 }}>{u.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '46px 32px' }}>
        <div className="footer-main-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1.2fr', gap: '38px', paddingBottom: '38px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>

          {/* Brand column */}
          <div>
            <div style={{ marginBottom: '20px' }}>
              <img src={logo} alt="DIRA HOLIDAYS" style={{ height: '45px', objectFit: 'contain' }} />
            </div>

            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.38)', lineHeight: 1.8, maxWidth: '218px', marginBottom: '20px' }}>
              India's most trusted travel brand. Crafting unforgettable journeys for 18+ years.
            </p>

            <div style={{ fontSize: '9px', fontWeight: 700, letterSpacing: '1.5px', color: 'rgba(255,255,255,0.3)', marginBottom: '12px', textTransform: 'uppercase' }}>Social</div>
            <div style={{ display: 'flex', gap: '12px', marginBottom: '28px' }}>
              {SOCIAL.map(s => (
                <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <div style={{ width: '36px', height: '36px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s' }}>
                    <img src={s.icon} alt={s.label} style={{ width: '20px', height: '20px' }} />
                  </div>
                </a>
              ))}
            </div>

            {/* Payment */}
            <div style={{ fontSize: '9px', fontWeight: 700, letterSpacing: '1.5px', color: 'rgba(255,255,255,0.3)', marginBottom: '12px', textTransform: 'uppercase' }}>Payment Options</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {PAYMENT_OPTIONS.map(p => (
                <div key={p.label} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '6px', padding: '6px 12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <img
                    src={p.icon}
                    alt={p.label}
                    style={{
                      height: '14px',
                      width: 'auto',
                    }}
                  />
                  <span style={{ fontSize: '10px', fontWeight: 600, color: 'rgba(255,255,255,0.52)' }}>{p.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Customer Service */}
          <div>
            <h4 style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '1.5px', color: 'var(--secondary)', margin: '0 0 16px', textTransform: 'uppercase' }}>Customer Service</h4>
            <div style={{ marginBottom: '14px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '3px' }}>
                <Icon name="chat" size={12} color="var(--secondary)" />
                <span style={{ fontSize: '12px', fontWeight: 600, color: '#fff' }}>Chat</span>
              </div>
              <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.38)', paddingLeft: '19px' }}>Mon–Sat: 10:00–18:00</div>
            </div>
            <div style={{ marginBottom: '14px' }}>
              <a href="https://wa.me/917092210922" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '3px' }}>
                  <Icon name="whatsapp" size={12} color="#25D366" />
                  <span style={{ fontSize: '12px', fontWeight: 600, color: '#fff' }}>WhatsApp Chat</span>
                </div>
                <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.38)', paddingLeft: '19px' }}>+91 70922 10922</div>
              </a>
            </div>
            <div style={{ marginBottom: '14px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '3px' }}>
                <Icon name="location" size={12} color="var(--secondary)" />
                <span style={{ fontSize: '12px', fontWeight: 600, color: '#fff' }}>Corporate Office</span>
              </div>
              <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.38)', paddingLeft: '19px', lineHeight: '1.4' }}>
                5/30, 2nd Floor, Bharathi Salai,<br />
                Near SRM college, Ramapuram,<br />
                Chennai-60089
              </div>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '3px' }}>
                <Icon name="faq" size={12} color="var(--secondary)" />
                <span style={{ fontSize: '12px', fontWeight: 600, color: '#fff' }}>FAQ's</span>
              </div>
              <a href="#faq" style={{ fontSize: '11px', color: 'var(--secondary)', paddingLeft: '19px', display: 'block' }}>FAQ Portal →</a>
            </div>
          </div>

          {/* Our Brands */}
          <div>
            <h4 style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '1.5px', color: 'var(--secondary)', margin: '0 0 16px', textTransform: 'uppercase' }}>Our Brands</h4>
            {BRAND_LINKS.map(l => <button key={l} className="footer-link">{l}</button>)}
          </div>

          {/* Destinations */}
          <div>
            <h4 style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '1.5px', color: 'var(--secondary)', margin: '0 0 16px', textTransform: 'uppercase' }}>Destinations</h4>
            {DEST_LINKS.map(l => <button key={l} className="footer-link">{l}</button>)}
          </div>

          {/* Support */}
          <div>
            <h4 style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '1.5px', color: 'var(--secondary)', margin: '0 0 16px', textTransform: 'uppercase' }}>Support</h4>
            {SUPPORT_LINKS.map(l => <button key={l} className="footer-link">{l}</button>)}
          </div>
        </div>

        {/* Legal bar */}
        <div style={{ paddingTop: '22px' }}>
          <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.28)', marginBottom: '10px', lineHeight: 1.8 }}>
            <span style={{ fontWeight: 600, color: 'rgba(255,255,255,0.42)' }}>Company: </span>
            {LEGAL_LINKS.map((l, i) => (
              <span key={l}>
                <a href="#legal" style={{ color: 'rgba(255,255,255,0.32)' }}>{l}</a>
                {i < LEGAL_LINKS.length - 1 && <span style={{ margin: '0 6px' }}>|</span>}
              </span>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
            <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.2)', margin: 0 }}>
              © 2025 DIRA HOLIDAYS Pvt. Ltd. · IATA Accredited · All Rights Reserved
            </p>
            <p style={{ fontSize: '10px', color: 'rgba(255,255,255,0.16)', margin: 0 }}>
              *Offer terms and conditions apply. Prices are per person based on twin share unless stated.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
